import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers'
import Stack from '@mui/material/Stack';
import moment from 'moment';
import ClearIcon from '@mui/icons-material/Clear';
import IconButton from '@mui/material/IconButton';

const Filters = ({ visible, meta, setMeta }) => {
    const claims = useSelector(state => state.claims);
    const profile = useSelector(state => state.auth.profile);
    const [formValues, setFormValues] = useState(meta)
    const [filterButtonDisabled, setFilterButtonDisabled] = useState(true)
    const [startDate, setStartDate] = React.useState(null);
    const [endDate, setEndDate] = React.useState(null);
    const [checkFormUse, setCheckFormUse] = useState("")
  
    const onInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues({
            ...formValues,
            [name]: value
        });
    };

    const submitFilterValues = () => {
        setMeta(prevState => ({
            ...prevState,
            [`claim_type`]: formValues["claim_type"],
            [`claim_status`]: formValues["claim_status"],
            [`start_date`]: formValues["start_date"],
            [`end_date`]: formValues["end_date"],
            [`page`]: 1
        }));
        setCheckFormUse(true)
    }

    const onDateChange = (date_type, date) => {
        if(date != "" && typeof date !== "undefined" && date !=  null){
           let date_formatted = (date != null) ? moment(date).format("YYYY-MM-DD") : date
           if(date_type == "start_date"){
                let start_date = date_formatted + " 00:00:00"
                start_date = moment(start_date).utc().format("YYYY-MM-DD HH:mm:ss")
                setStartDate(date_formatted)
                setFormValues({
                    ...formValues,
                    [`start_date`]: start_date
                });
           }else{
                let end_date = date_formatted + " 23:59:59"
                end_date = moment(end_date).utc().format("YYYY-MM-DD HH:mm:ss")
                setEndDate(date_formatted)
                setFormValues({
                    ...formValues,
                    [`end_date`]: end_date
                });
           }
        }
    }

    const resetFields = () => {
        setStartDate(null)
        setEndDate(null)
        setFormValues({
            ...formValues,
            [`claim_type`]: "",
            [`claim_status`]: "",
            [`start_date`]: "",
            [`end_date`]: "",
        });
        setMeta(prevState => ({
            ...prevState,
            [`claim_type`]: "",
            [`claim_status`]: "",
            [`start_date`]: "",
            [`end_date`]: "",
            [`page`]: 1
        }));
    }

    const checkFormHasValues = () => {
        let disableButton = true
        if (formValues["claim_type"] !== "" || formValues["claim_status"] !== "" || formValues["start_date"] !== ""  || formValues["end_date"] !== "") {
            disableButton = false
        }

        return disableButton
    }

    useEffect(() => {
        setCheckFormUse("")
        setFilterButtonDisabled(checkFormHasValues())
    }, [formValues])

    useEffect(() => {
        if ((formValues["claim_type"]!== "" || formValues["claim_status"] !== "" || formValues["start_date"] !== "" || formValues["end_date"] !== "") && checkFormUse === '') {
            setFormValues({
                ...formValues,
                [`claim_type`]: "",
                [`claim_status`]: "",
                [`start_date`]: "",
                [`end_date`]: ""
            });
            setMeta(prevState => ({
                ...prevState,
                [`claim_type`]: "",
                [`claim_status`]: "",
                [`start_date`]: "",
                [`end_date`]: "",
                [`page`]: 1
            }));
            setStartDate(null)
            setEndDate(null)
        }
    }, [claims])
    return (
        <>
            {visible &&
                <div className="filtercontainer">
                    <div className="filteraccordion" id="sc-filteraccordion">
                        <Box
                            component="form"
                            sx={{
                                '& > :not(style)': { m: 1 },
                            }}

                            noValidate
                            autoComplete="off"
                        >
                                <FormControl className="sc__minwidth--align" variant="standard" sx={{ m: 1, minWidth: 270 }}>
                                    <InputLabel id="carrier-name-select-label" size={'small'}>Claim Type</InputLabel>
                                    <Select
                                        value={formValues && formValues.claim_type}
                                        name={"claim_type"}
                                        labelId="carrier-name-select-label"
                                        id="demo-simple-select"
                                        onChange={onInputChange}>
                                        <MenuItem value={"LOST"}>Lost</MenuItem>
                                        <MenuItem value={"DAMAGE"}>Damage</MenuItem>
                                        <MenuItem value={"MISDELIVERY"}>Misdelivery</MenuItem>
                                        <MenuItem value={"MISSING"}>Missing</MenuItem>
                                        <MenuItem value={"UNUSED"}>Unused</MenuItem>
                                    </Select>
                                </FormControl>
                            <FormControl  className="sc__minwidth--align" variant="standard" sx={{ m: 1, minWidth: 270 }}>
                                <InputLabel id="order-status-select-label" size={'small'}>Claim Status</InputLabel>
                                <Select
                                    value={formValues && formValues.claim_status}
                                    name={"claim_status"} labelId="order-status-select-label"
                                    id="demo-simple-select"
                                    onChange={onInputChange}>
                                    <MenuItem value={"PENDING"}>PENDING</MenuItem>
                                    <MenuItem value={"APPROVED"}>APPROVED</MenuItem>
                                    <MenuItem value={"DENIED"}>DENIED</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl variant="standard" sx={{ m: 1, minWidth: 370 }}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <Stack spacing={3} style={{flexDirection:'row'}}>
                                        <DatePicker
                                            label="Start Date"
                                            value={startDate}
                                            disableFuture={true}
                                            inputFormat={"yyyy-MM-dd"}
                                            onChange={(newValue) => {
                                                onDateChange("start_date",newValue);
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                variant="standard"
                                                label="Star Date"
                                                size={'small'}
                                                {...params}
                                                />
                                            )}
                                        />
                                        <DatePicker
                                            label="End Date"
                                            value={endDate}
                                            disableFuture={true}
                                            inputFormat={"yyyy-MM-dd"}
                                            onChange={(newValue) => {
                                                onDateChange("end_date",newValue);
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                variant="standard"
                                                label="End Date"
                                                size={'small'}
                                                {...params}
                                                />
                                            )}
                                        />
                                    </Stack>
                                </LocalizationProvider>
                            </FormControl>
                        </Box>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={12}>
                                <div className="filterfooter">
                                    <Button variant="contained" onClick={submitFilterValues} disabled={filterButtonDisabled}>Filter</Button>
                                    <Button variant="outlined" onClick={resetFields} disabled={filterButtonDisabled}>Clear</Button>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            }
        </>
    )

}

export default Filters;
